import { createFileRoute, redirect } from '@tanstack/react-router';

import { getUserSession } from '@/server/user';

export const Route = createFileRoute('/_protected/t/$tenantId/conversation/')({
  beforeLoad: async ({ params: { tenantId } }) => {
    const session = await getUserSession();
    const lastVisitedConversationId = session.experience?.lastVisitedConversationId;

    if (lastVisitedConversationId) {
      throw redirect({
        to: '/t/$tenantId/conversation/$conversationId',
        params: { tenantId, conversationId: lastVisitedConversationId },
      });
    }

    throw redirect({ to: '/t/$tenantId/conversation/new', params: { tenantId } });
  },
});
